import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';

interface SentimentOption {
  label: string;
  value: string;
}

interface FormData {
  message: string;
  sentiment: string;
  confidence_score: number;
  flag_status: boolean;
  predicted_sentiment: string;
  language: string;
  lang: string;
}

@Component({
  selector: 'app-sentiment-analysis-data-generate',
  templateUrl: './sentiment-analysis-data-generate.component.html',
  styleUrls: ['./sentiment-analysis-data-generate.component.scss'],
})
export class SentimentAnalysisDataGenerateComponent implements OnInit {
  @Input() formdatareceive!: FormData;
  @Input() maxKey!: string;
  @Input() responsereceive!: any;

  selectedSentiment!: string;
  receiveformData!: FormData;
  receiveResponse!: any;

  addTextForm!: FormGroup;
  formData: FormData = {
    message: "",
    sentiment: "",
    confidence_score: 1,
    flag_status: false,
    predicted_sentiment: "",
    language: "",
    lang: ""
  };
  sentimentOptions: SentimentOption[] = [];

  constructor(
    private fb: FormBuilder,
    private modalCtrl: ModalController,
    private apiService: ApiService,
    private alertController: AlertController,
    private globalService: GlobalService,
  ) { }

  setSentimentOptions(language: string): void {
    this.sentimentOptions = language === 'nl' 
      ? [
          { label: 'Positief', value: 'Positief' },
          { label: 'Negatief', value: 'Negatief' },
          { label: 'Neutraal', value: 'Neutraal' }
        ]
      : [
          { label: 'Positive', value: 'Positive' },
          { label: 'Negative', value: 'Negative' },
          { label: 'Neutral', value: 'Neutral' }
        ];
  }
  
  ngOnInit(): void {
    this.initializeComponent();
    this.setupForm();
    this.setupFormSubscriptions();
  }

  private initializeComponent(): void {
    this.receiveformData = this.formdatareceive;
    this.selectedSentiment = this.maxKey;
    this.receiveResponse = this.responsereceive;
    this.setSentimentOptions(this.formdatareceive.lang);
  }

  private setupForm(): void {
    const predictedSentiment = this.receiveformData?.predicted_sentiment;
    const flagStatus = this.selectedSentiment === predictedSentiment;

    this.addTextForm = this.fb.group({
      message: [{ value: this.receiveformData?.message || '', disabled: true }],
      sentiment: [this.selectedSentiment || ''],
      confidence_score: [this.receiveResponse?.confidence_score || 0],
      flag_status: flagStatus,
      predicted_sentiment: [this.receiveResponse?.predicted_sentiment || 0],
      language: [{ value: this.receiveformData?.lang || '', disabled: true }],
    });
  }

  private setupFormSubscriptions(): void {
    this.addTextForm.get('sentiment')?.valueChanges.subscribe((newSentiment) => {
      const predicted = this.receiveResponse?.predicted_sentiment;
      const isDifferent = newSentiment !== predicted;

      this.addTextForm.patchValue({
        flag_status: isDifferent
      });
    });
  }

  onSubmit(): void {
    if (this.addTextForm.valid) {
      const formData = this.addTextForm.getRawValue();
      this.globalService.logoutLoading();

      this.apiService.sentimentmodelAddData(formData).subscribe({
        next: (response) => {
          this.modalCtrl.dismiss(response);
          this.globalService.dismissLoading();
        },
        error: async (error) => {
          const alert = await this.alertController.create({
            header: 'Error',
            message: error.message || 'Failed to save sentiment data. Please try again.',
            buttons: ['OK']
          });
          await alert.present();
          this.globalService.dismissLoading();
        }
      });
    }
  }

  onCancel(): void {
    this.modalCtrl.dismiss();
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
